/* Header drawer — ~0.4KB. <details> handles open/close; this adds
   backdrop-click, Escape, and close-button behavior. Degrades to native. */
(function () {
  var drawer = document.getElementById('menu-drawer');
  if (!drawer) return;

  function close() { drawer.removeAttribute('open'); }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.hasAttribute('open')) close();
  });
})();

/* Inline search overlay — opens from the search icon, live product suggestions. */
(function () {
  var root = document.querySelector('[data-search]');
  var openBtn = document.querySelector('[data-search-open]');
  if (!root || !openBtn) return;
  var input = root.querySelector('[data-search-input]');
  var results = root.querySelector('[data-search-results]');
  var form = root.querySelector('form');
  var action = form ? form.getAttribute('action') : '/search';
  var timer;

  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 80);
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function render(products, q) {
    if (!products.length) { results.innerHTML = '<p class="hsearch__empty">No products found.</p>'; return; }
    var html = products.map(function (p) {
      var img = p.image || (p.featured_image && p.featured_image.url) || '';
      return '<a class="hsearch__item" href="' + esc(p.url) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="52" height="52">' : '') +
        '<span><span class="hsearch__item-title">' + esc(p.title) + '</span>' +
        (p.price ? '<span class="hsearch__item-price">' + esc(p.price) + '</span>' : '') + '</span>' +
      '</a>';
    }).join('');
    html += '<a class="hsearch__all" href="' + action + '?q=' + encodeURIComponent(q) + '&type=product">View all results</a>';
    results.innerHTML = html;
  }

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(products, q);
          })
          .catch(function () {});
      }, 220);
    });
  }
})();

/* Sticky-on-scroll header — becomes fixed once you scroll past it. ~0.4KB.
   Uses a spacer to prevent content jump. */
(function () {
  var header = document.querySelector('.header');
  if (!header) return;
  var start = header.getBoundingClientRect().top + window.pageYOffset;
  var spacer = document.createElement('div');
  spacer.setAttribute('aria-hidden', 'true');
  spacer.style.display = 'none';
  header.after(spacer);
  var stuck = false;

  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (!stuck && y > start) {
      spacer.style.height = header.offsetHeight + 'px';
      spacer.style.display = 'block';
      header.classList.add('is-stuck');
      stuck = true;
    } else if (stuck && y <= start) {
      header.classList.remove('is-stuck');
      spacer.style.display = 'none';
      stuck = false;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (!stuck) start = header.getBoundingClientRect().top + window.pageYOffset;
  });
  onScroll();
})();
